import React from 'react'
import styles from './loginNew.less'
import { Button, Form, Icon, Input, notification, Tabs } from 'antd'
import logo from '../../assets/tvision.png'
import Request from '../../request'
import { hideLoader, showLoader } from '../../modules/actions'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

const { TabPane } = Tabs;

class NormalLoginForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            isUser: false,
            key: 1,
            loadLoginForm: false,
            activeTab: "password",
            forgotPassword: false,
            forgotOtp: false
        }
    }

    componentDidMount() {
        let searchParams = new URLSearchParams(this.props.search);
        let authorization = searchParams.get("authorization") ? searchParams.get("authorization") : localStorage.getItem('token');
        let impersonate = searchParams.get("impersonate");
        let verifyIP = searchParams.get("verify") ? searchParams.get("verify") : 'no';

        if (impersonate) {
            this.handleImpersonationLogin(impersonate);
        } else if (authorization) {
            this.checkAuthorizationToken(authorization, verifyIP);
        } else {
            this.setState({ loadLoginForm: true });
        }
        // if (!authorization || authorization === "undefined") {
        //     this.setState({ loadLoginForm: true });
        // } else {
        //     this.checkAuthorizationToken(authorization, verifyIP);
        // }
    }

    handleImpersonationLogin = async (token) => {
        const { dispatch } = this.props
        const response = await Request.impersonateLogin(token);
        if (!response.error) {
            localStorage.setItem('token', response.token);
            localStorage.setItem('user', JSON.stringify(response.user));
            localStorage.setItem('rights', JSON.stringify(response.userRights));
            dispatch({ type: 'SET_CURRENT_USER', user: response.user });
            window.location.href = "/dashboard";
        } else {
            window.history.replaceState({}, document.title, "/login");
            const keysToRemove = [
                'token',
                'user',
                'rights',
                'company-details',
                'menuCollapsed',
                'timerStartTime',
            ];

            keysToRemove.forEach(key => localStorage.removeItem(key));

            notification.error({ message: response.message });

            this.setState({ loadLoginForm: true });
            setTimeout(() => {
                window.location.href = "/login";
            }, 800)
        }
    }

    checkAuthorizationToken = async (token, verifyIP = 'yes') => {
        const { dispatch } = this.props
        const response = await Request.getAuthorizationTokenUser(token, verifyIP);
        // const response = await Request.impersonateLogin(token);
        if (!response.error) {
            localStorage.setItem('token', response.token);
            localStorage.setItem('user', JSON.stringify(response.user));
            localStorage.setItem('rights', JSON.stringify(response.userRights));
            dispatch({ type: 'SET_CURRENT_USER', user: response.user });
            window.location.href = "/dashboard";
        } else {
            notification.error({ message: response.message });
            this.setState({ loadLoginForm: true });
        }
    }

    handleSubmit = e => {
        const { dispatch } = this.props;
        e.preventDefault();
        const { activeTab, forgotPassword } = this.state;

        if (forgotPassword) {
            this.props.form.validateFields(async (err, values) => {
                if (!err) {
                    dispatch(showLoader());
                    this.setState({ loading: true });
                    let x = await Request.forgotPassword(values);
                    if (x.otpSent) {
                        this.setState({ forgotOtp: true });
                    } else if (x.success && !x.otpSent) {
                        this.setState({ forgotOtp: false, forgotPassword: false });
                    }
                    this.setState({ loading: false });
                    dispatch(hideLoader());
                    x.success ? notification.success({ message: x.message }) : notification.error({ message: x.message });
                }
            });
        } else {
            const fieldsToValidate = activeTab === 'password' ? ['email', 'password'] : ['email_otp', 'otp'];
            this.props.form.validateFields(fieldsToValidate, async (err, values) => {
                if (!err) {
                    values.loginType = activeTab;
                    dispatch(showLoader());
                    this.setState({ loading: true });
                    let x = await Request.login(values);
                    if (x.token) {

                        localStorage.setItem('token', x.token);
                        localStorage.setItem('user', JSON.stringify(x.user));
                        localStorage.setItem('rights', JSON.stringify(x.userRights));
                        if (x.lastLogin) localStorage.setItem('timerStartTime', x.lastLogin);
                        dispatch({ type: 'SET_CURRENT_USER', user: x.user });
                        window.location.href = "/dashboard";
                    } else if (x.otpSent) {
                        this.setState({ isUser: true });
                    }
                    this.setState({ loading: false });
                    dispatch(hideLoader());
                    x.success ? notification.success({ message: x.message }) : notification.error({ message: x.message });
                }
            });
        }
    };

    handleTabChange = (key) => this.setState({ activeTab: key });
    handleForgotPasswordClick = (e) => { e.preventDefault(); this.setState({ forgotPassword: true }); }
    handleBackToLoginClick = (e) => { e.preventDefault(); this.setState({ forgotPassword: false }); }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { key, isUser, loadLoginForm, activeTab, forgotPassword, forgotOtp, loading } = this.state;

        return (
            <div className={styles.loginPage}>
                <div className={styles.loginContainer}>
                    <div className={styles.loginCard}>
                        <Form key={key} onSubmit={this.handleSubmit} className={styles.loginForm}>
                            <div className={styles.logoWrapper}>
                                <Link to="/">
                                    <img alt="logo" className={styles.logo} src={logo} />
                                </Link>
                                <h2 className={styles.title}>{forgotPassword ? 'Reset Password' : 'Welcome Back'}</h2>
                                <p className={styles.subtitle}>{forgotPassword ? 'Enter email to receive OTP' : 'Login to your account'}</p>
                            </div>

                            {loadLoginForm ? (
                                <div className={styles.formContent}>
                                    {!forgotPassword ? (
                                        <Tabs activeKey={activeTab} onChange={this.handleTabChange} animated={true}>
                                            <TabPane tab={<span><Icon type="unlock" />Password</span>} key="password">
                                                <Form.Item>
                                                    {getFieldDecorator('email', { rules: [{ required: true, message: 'Please input your username!' }] })(
                                                        <Input prefix={<Icon type="user" />} size="large" placeholder="Username" />
                                                    )}
                                                </Form.Item>
                                                <Form.Item>
                                                    {getFieldDecorator('password', { rules: [{ required: true, message: 'Please input your Password!' }] })(
                                                        <Input.Password prefix={<Icon type="lock" />} size="large" placeholder="Password" />
                                                    )}
                                                </Form.Item>
                                                <div className={styles.actions}>
                                                    <Button type="primary" htmlType="submit" size="large" loading={loading} block className={styles.submitBtn}>
                                                        LOG IN
                                                    </Button>
                                                    <a className={styles.forgotLink} onClick={this.handleForgotPasswordClick}>Forgot Password?</a>
                                                </div>
                                            </TabPane>

                                            <TabPane tab={<span><Icon type="mobile" />OTP</span>} key="otp">
                                                <Form.Item>
                                                    {getFieldDecorator('email_otp', { rules: [{ required: true, message: 'Please input your username!' }] })(
                                                        <Input prefix={<Icon type="user" />} size="large" placeholder="Username" />
                                                    )}
                                                </Form.Item>
                                                {isUser && (
                                                    <Form.Item>
                                                        {getFieldDecorator('otp', { rules: [{ required: true, message: "Input 4-digit OTP!" }] })(
                                                            <Input prefix={<Icon type="safe" />} size="large" placeholder="Enter OTP" />
                                                        )}
                                                    </Form.Item>
                                                )}
                                                <Button type="primary" htmlType="submit" size="large" loading={loading} block className={styles.submitBtn}>
                                                    {isUser ? "VERIFY & LOGIN" : "SEND OTP"}
                                                </Button>
                                            </TabPane>
                                        </Tabs>
                                    ) : (
                                        <div className={styles.forgotSection}>
                                            <Form.Item>
                                                {getFieldDecorator('forgot_email', { rules: [{ required: true, message: 'Please input email!' }] })(
                                                    <Input prefix={<Icon type="mail" />} size="large" placeholder="Recovery Email" />
                                                )}
                                            </Form.Item>
                                            {forgotOtp && (
                                                <>
                                                    <Form.Item>
                                                        {getFieldDecorator('otp', { rules: [{ required: true, message: "Input OTP!" }] })(
                                                            <Input prefix={<Icon type="safe" />} size="large" placeholder="OTP" />
                                                        )}
                                                    </Form.Item>
                                                    <Form.Item>
                                                        {getFieldDecorator('forgot_password', { rules: [{ required: true, message: 'Input New Password!' }] })(
                                                            <Input.Password prefix={<Icon type="lock" />} size="large" placeholder="New Password" />
                                                        )}
                                                    </Form.Item>
                                                </>
                                            )}
                                            <Button type="primary" htmlType="submit" size="large" loading={loading} block className={styles.submitBtn}>
                                                {forgotOtp ? "RESET PASSWORD" : "SEND RESET CODE"}
                                            </Button>
                                            <div className={styles.backLogin}>
                                                <a onClick={this.handleBackToLoginClick}><Icon type="arrow-left" /> Back to Login</a>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className={styles.redirecting}>
                                    <Icon type="loading" style={{ fontSize: 24, marginBottom: 10 }} spin />
                                    <p>Redirecting you securely...</p>
                                </div>
                            )}
                        </Form>
                    </div>
                </div>
            </div>
        )
    }
}

const WrappedNormalLoginForm = Form.create()(NormalLoginForm)
const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search,
})
export default connect(mapStateToProps)(WrappedNormalLoginForm)